import React, {
  memo, useMemo,
} from 'react';
import classes from './Attributes.scss';
import ThumbButtonGroup from './ThumbButtonGroup';
import { AttributesProps } from '../types.d';

const Attributes = ({
  questions,
  selectedAttribute,
  setSelectedAttribute,
  statusId,
}: AttributesProps): React.ReactElement => {
  const isAttributeSelected = (attributeId: number) => selectedAttribute?.includes(attributeId);

  const filteredAttributes = useMemo(() => {
    const attributes = questions?.[0]?.attributes ?? [];
    if (statusId && statusId <= 3) {
      return attributes.filter((att) => att?.visibilityStage === 'pre_complete');
    }
    return attributes;
  }, [questions, statusId]);

  const itemClickEvent = (itemId: number): void => {
    const target = (selectedAttribute ?? []).find((id) => Math.abs(id) === Math.abs(itemId));
    if (!target) {
      setSelectedAttribute([...selectedAttribute, itemId]);
    } else if (target === itemId) {
      setSelectedAttribute((selectedAttribute ?? []).filter((id) => id !== itemId));
    } else {
      setSelectedAttribute(
        (selectedAttribute ?? []).map((id) => (Math.abs(id) === Math.abs(itemId) ? id * -1 : id)),
      );
    }
  };

  return (
    <section data-testid="attribute">
      <div className={classes.item__content}>
        {filteredAttributes.map((att) => (
          <div className={classes.attribute__chip} key={att?.attributeId}>
            <ThumbButtonGroup
              label={att?.name}
              onPositiveClick={() => itemClickEvent(att?.attributeId)}
              onNegativeClick={() => itemClickEvent(att?.attributeId * -1)}
              isPositiveSelected={isAttributeSelected(att?.attributeId)}
              isNegativeSelected={isAttributeSelected(att?.attributeId * -1)}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default memo(Attributes);
